
import React, { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";

import toast from "react-hot-toast";
import { useNavigate } from "react-router";
import { useAuth } from "./AuthContext";
import { CommonContext } from "../../App";
import { useContext } from "react";
import LoadingSpinner from "../CommonComponent/loadingSpiner/LoadingSpinner";
import { useTranslation } from "react-i18next";
import image from '../../assets/zilitoName.png'
import api from "../../services/api";
import axios from "axios";
import { useEffect } from "react";
export default function Login() {
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const navigate = useNavigate();
  const { login } = useAuth();
  const { setUserData } = useContext(CommonContext);
  const { t, } = useTranslation();
  const API_BASE = process.env.REACT_APP_BASE_URL;

  const [showSplash, setShowSplash] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowSplash(false);
    }, 4000); // 5 seconds

    return () => clearTimeout(timer);
  }, []);

  const validate = () => {
    let tempErrors = {};

    if (!phone) tempErrors.phone = "Phone number is required";
    else if (!/^\d{1,10}$/.test(phone)) tempErrors.phone = "Phone must be numeric and max 10 digits";

    if (!password) tempErrors.password = "Password is required";

    setErrors(tempErrors);
    return Object.keys(tempErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;
    setIsLoggingIn(true);
    try {
      const res = await axios.post(
        `${API_BASE}auth/login`,
        { phone, password },
        { withCredentials: true }
      );
      // console.log("login response==>>", res)

      if (res.data.success) {
        toast.success("Login successful");
        login(res.data.user);
        setUserData({ user: res.data.user, token: "" });
        navigate("/");
      } else {
        toast.error(res.data.message || "Login failed");
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Login failed");
    } finally {
      setIsLoggingIn(false);
    }
  };



  // if (isLoggingIn) {
  //   return <LoadingSpinner size={80} color={"#000000"} />;
  // }

  // if (showSplash) {
  //   return (
  //     <div className={`fixed inset-0 flex items-center justify-center bg-white transition-opacity duration-700 ${showSplash ? "opacity-100" : "opacity-0 pointer-events-none"
  //       }`}>
  //       <img
  //         src={image} // your splash logo
  //         alt="Splash Logo"
  //         className="w-40 h-40 animate-splash"
  //       />
  //     </div>
  //   );
  // }


  return (
    <div className="flex min-h-screen">

       <div className={`fixed inset-0 z-50 flex items-center justify-center bg-white transition-opacity duration-700 ${showSplash ? "opacity-100" : "opacity-0 pointer-events-none"
        }`}>
        <img
          src={image} // your splash logo
          alt="Splash Logo"
          className="max-w-[80vw] max-h-[80vh] w-32 sm:w-40 md:w-52 lg:w-64 h-auto animate-splash"
        />
      </div>

      <div
        className="hidden w-1/2 bg-theme-sidebarBg bg-center bg-no-repeat bg-contain md:flex"
        style={{
          backgroundImage:
            "url('https://static.vecteezy.com/system/resources/previews/015/153/198/non_2x/3d-illustration-financial-management-concept-and-investment-banner-template-of-payment-with-money-free-png.png')",
        }}
      ></div>


      <div className="flex items-center justify-center w-full p-8 md:w-1/2 bg-gray-50">
        <div className="w-full max-w-md p-8 bg-white rounded-lg  shadow-2xl shadow-theme-sidebarBg">
          <div className="mb-4 flex justify-center">
            <img src={image} height={150} width={250} alt="zilito image" />
          </div>

          <form className="space-y-4" onSubmit={handleSubmit}>
            <div>
              <label className="block mb-1 text-sm font-medium text-gray-700">{t('phone')}</label>
              <input
                type="tel"
                placeholder="Enter your phone number"
                className="w-full px-2 py-2 border rounded-md focus:outline-none"
                value={phone}
                onChange={(e) => setPhone(e.target.value.replace(/\D/, ""))}
                maxLength={10}
              />
              {errors.phone && <p className="mt-1 text-sm text-red-500">{errors.phone}</p>}
            </div>

            <div className="relative">
              <label className="block mb-1 text-sm font-medium text-gray-700">{t('password')}</label>
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Enter your password"
                className="w-full px-2 py-2 pr-10 border rounded-md focus:outline-none"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <div
                className={`absolute ${errors.password ? "top-1/3 mt-[2px] " : "top-1/2"} right-3 transform -translate-y-1/2 cursor-pointer text-gray-500`}
                onClick={() => setShowPassword(!showPassword)}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </div>
              {errors.password && <p className="mt-1 text-sm text-red-500">{errors.password}</p>}

              <div className="mt-1 text-right">
                <button
                  type="button"
                  className="text-sm font-medium text-black hover:underline"
                  onClick={() => toast("Password reset flow coming soon!")}
                >
                  {t('forgetPassword')}
                </button>
              </div>
            </div>

            <button
              type="submit"
              className="w-full py-2 text-white transition-colors rounded-md bg-theme-sidebarBg hover:bg-gray-800"
            >
              {t('login')}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}


